import { render } from "./SectionsAnalytics.vue?vue&type=template&id=6499db96&scoped=true"
import script from "./SectionsAnalytics.vue?vue&type=script&lang=js"
export * from "./SectionsAnalytics.vue?vue&type=script&lang=js"

import "./SectionsAnalytics.vue?vue&type=style&index=0&id=6499db96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6499db96"]])

export default __exports__